import {useEffect, useState, React} from 'react'
import Alert from 'react-bootstrap/Alert';

const Error = ({children}) => {
  return (
    <Alert variant="danger">
        <h5 >{children}</h5>
    </Alert>
  )
}

export default Error